import styled, { css } from 'styled-components';
import mq from '../../../utils/mediaQueries.js';
import { isGlobetrotter } from '../../../utils/theming.js';

// @ts-nocheck
var Bullets = styled.ul.withConfig({
  displayName: "Bulletsstyle__Bullets",
  componentId: "sc-1cp3dl7-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;column-gap:var(--space-500);row-gap:var(--space-100);"]);
var Bullet = styled.li.withConfig({
  displayName: "Bulletsstyle__Bullet",
  componentId: "sc-1cp3dl7-1"
})(["list-style-type:disc;margin:0 0 0 var(--space-400);", " ", ""], isGlobetrotter(css(["font:var(--font-body-s);color:var(--color-text-subtle);"])), mq.sMax(css(["flex-basis:100%;"])));

export { Bullet, Bullets };
//# sourceMappingURL=Bullets.style.js.map
